import styled from '@emotion/styled';

import { SPACING, MEDIA_QUERY } from '@zola/zola-ui/src/styles/emotion';

export const Container = styled('div', {
  shouldForwardProp: prop => !['backgroundColor', 'fontColor'].includes(prop as string),
})<{ backgroundColor: string; fontColor: string }>`
  padding: ${SPACING.SM};
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  ${({ backgroundColor, fontColor }) => `
      background-color: #${backgroundColor};
      color: #${fontColor};
    `}
  ${MEDIA_QUERY.DESKTOP} {
    align-items: center;
    padding: ${SPACING.SM} ${SPACING.S32};
  }
`;

export const Text = styled.div`
  max-width: 800px;
  width: 100%;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
`;
